const checkWebPSupport = (): boolean => {
  if (typeof window === 'undefined') return false

  const canvas = document.createElement('canvas')
  canvas.width = 1
  canvas.height = 1
  return canvas.toDataURL('image/webp').indexOf('data:image/webp') === 0
}

let webpSupported: boolean | null = null

export const useSquads = () => {
  const getAchievementImageUrl = (id: number | string) => {
    if (typeof window !== 'undefined') {
      if (webpSupported === null) {
        webpSupported = checkWebPSupport()
      }

      const isRetina = window.devicePixelRatio >= 2
      const basePath = `/static/images/achievements/${id}`

      if (webpSupported && isRetina) {
        return `${basePath}/img@2x.webp`
      } else if (webpSupported) {
        return `${basePath}/img.webp`
      } else if (isRetina) {
        return `${basePath}/img@2x.png`
      }
    }

    return `/static/images/achievements/${id}.png`
  }

  return {
    getAchievementImageUrl
  }
}
